import { Box, ColorPicker } from '@wix/design-system';
import React__default, { useContext } from 'react';
import { RicosContext } from 'ricos-context';
import { s as styleInject } from '../../../style-inject.es-e7b07dd7.js';
import { FloatingLayout } from '../../../modal-layout/floating-layout/floating-layout.js';
import '../../../modal-layout/floating-layout/floating-desktop-layout.js';
import 'classnames';
import '../../../ui-components-provider.js';
import '../../../modal-layout/floating-layout/data-hooks.js';
import '../../../modal-layout/fullscreen-mobile-layout/fullscreen-mobile-layout.js';
import '../../../modal-layout/fullscreen-mobile-layout/data-hooks.js';

var css_248z = "._7pbBB{display:flex;justify-content:center}[dir] ._7pbBB{box-shadow:0 0 18px rgba(0,6,36,.1),0 6px 6px rgba(0,6,36,.05);margin-bottom:12px}";
var classes = {"colorPicker":"_7pbBB"};
styleInject(css_248z);

const FloatingCustomColorPicker = ({
  title,
  color,
  onCancel,
  onConfirm,
  allowEmpty
}) => {
  const { t, isMobile } = useContext(RicosContext);
  return /* @__PURE__ */ React__default.createElement(
    FloatingLayout,
    {
      onCloseButtonClick: onCancel,
      sidePanelProps: {
        height: "fit-content",
        width: isMobile ? "100%" : "fit-content"
      },
      header: isMobile ? {
        title
      } : void 0,
      content: {
        children: /* @__PURE__ */ React__default.createElement(Box, { align: "center" }, /* @__PURE__ */ React__default.createElement(
          "div",
          {
            className: isMobile ? classes.colorPicker : void 0,
            tabIndex: 0,
            "aria-label": title
          },
          /* @__PURE__ */ React__default.createElement(
            ColorPicker,
            {
              value: color != null ? color : "",
              showConverter: false,
              onChange: () => {
              },
              onConfirm: (color2) => {
                const colorHex = typeof color2 === "string" ? color2 : color2.hex();
                onConfirm(colorHex);
              },
              onCancel,
              allowEmpty,
              emptyPlaceholder: t("CustomColorPicker_Empty_Placeholder")
            }
          )
        ))
      }
    }
  );
};

export { FloatingCustomColorPicker };
//# sourceMappingURL=floating-custom-color-picker.js.map
